import { ErrorScreen, LockArt, buttonClass } from '@/components';
import { A } from '@solidjs/router';

export default function Forbidden() {
  return (
    <ErrorScreen
      art={<LockArt />}
      title="Access denied"
      body="You don't have permission to access this resource."
      action={
        <A
          href="/devices"
          class={`${buttonClass('primary', 'lg')} min-w-44 shadow-lg shadow-brand-600/30`}
        >
          Back to devices
        </A>
      }
    />
  );
}
